import { createApp } from "vue";
import App from "./App.vue";
import no_double_click from "./libs/no-double-click.js";
import GlobalEnv from "./libs/GlobalEnv.js";
// import mpLog from './libs/mpLog/mpLog';
// import logConfig from './libs/mpLog/logConfig';
import { createI18n } from "vue-i18n";
import { en, zhHans, zhHant } from "../locale/index.js";
import "./styles/variety-font/index.js";
import { setStorage } from "@/utils/storage";
import { countryToLanguage, countryToCountry } from "@/utils/common.js";
import Antd from "ant-design-vue";
import Vconsole from "vconsole";
import "ant-design-vue/dist/reset.css";
import "@/utils/flexiable.js";

// mpLog.init({
// 	enable: true,
// 	log: {
// 		trking: {
// 			host: 'cn-beijing.log.aliyuncs.com',
// 			project: 'popfe',
// 			logstore: 'popService_oversea_h5'
// 		},
// 		maxLength: 10,
// 		...logConfig
// 	}
// });

const messages = {
  en,
  "zh-hans": zhHans,
  "zh-hant": zhHant,
};

// pathname转为小写后重新刷新下页面
const currentPathname = window.location.pathname;
const lowerCasePathname = currentPathname.toLowerCase();
// 如果当前pathname包含大写字母，则重定向到小写版本
if (currentPathname !== lowerCasePathname) {
  const newUrl =
    window.location.origin + lowerCasePathname + window.location.hash;
  window.location.replace(newUrl);
}
const country = window.location.pathname.replaceAll("/", "") || "us";
let i18nConfig = {
  legacy: false, // you must set `false`, to use Composition API
  locale: countryToLanguage(country), //这里是设置你vue页面中要使用哪种语言,获取已设置的语言 uni-getLocale()
  messages,
};
const i18n = createI18n(i18nConfig);

setStorage("LANGUAGE", i18nConfig.locale);
setStorage("countryStorage", countryToCountry(country || "us"));

const app = createApp(App);
app.config.globalProperties.$no_double_click = no_double_click;
app.config.globalProperties.$globalEnv = GlobalEnv;

if (process.env.DEFINE_NODE_ENV !== "prod") {
  const vConsole = new Vconsole();
  app.use(vConsole);
}
app.use(i18n);
app.use(Antd);
app.mount("#app");
